// extracted by mini-css-extract-plugin
module.exports = {"root":"PeopleTab_root__2NhDp","card":"PeopleTab_card__37nX4","invite":"PeopleTab_invite__3aoaO","stack":"PeopleTab_stack__2VHKn","note":"PeopleTab_note__NET8q"};